<div>
  <cx-media
    [container]="getContainer()"
    format="product"
    [alt]="item.name ?? ''"
  ></cx-media>
  <h3 class="cx-product-name" tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
    {{ item.name }}
  </h3>
  <div class="price">
    {{ item.price?.formattedValue }}
  </div>
  <app-gonvarri-chapa-quantity
    [product]="item"
    [packageWeigth]="packageWeight"
    [numberOfSheets]="numberOfSheets"
    [lenght]="largoDeseado"
    (updatePackageAndSheets)="updateValues($event)"
    (disableAddToCart)="updateIsDisabled($event)"
    [hideTexts]="true"
  />
  <cx-add-to-cart
    [productCode]="passThrought(item.code)"
    [packageWeight]="packageWeight"
    [numberOfSheets]="numberOfSheets"
    [length]="largoDeseado"
    [isDisabled]="disableAddToCart"
    [isContract]="isContract"
    [product]="item"
    [showQuantity]="true"
    [hideTexts]="true"
    class="add-to-cart"
    [pickupStore]=""
    [options]="{
      isSaveForLater: false,
      optionalBtn: false,
      displayAddToCart: true,
      addToCartString: 'addToCart.addToCart' | cxTranslate
    }"
    [showAddToCart]="largoDeseado < 350"
  />
</div>
<div class="actions">
  <ng-container cxInnerComponentsHost></ng-container>
</div>
